import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=2f913746"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"
import style0 from "./NewGroup.vue?vue&type=style&index=0&id=2f913746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports